import React, { Component } from "react";
import { Modal, ModalHeader, ModalBody} from "reactstrap";
import { Alert } from "reactstrap";
import Dropzone from "react-dropzone";
import { ClipLoader } from "react-spinners";


class UploadFileModal extends Component {
    constructor(props) {
        super(props);
        this.data = null;
        this.state = {
            file: null,
            modal: false,
            loading: false,
        };
    }

    toggle = () => {
        this.setState({
            modal: !this.state.modal,

        });
    };
    onSubmit = () => {
        this.setState({ loading: true });
        this.props
            .onSubmit(this.state.file)
            .then(() => {
                this.toggle();
                this.setState({
                    loading: false,
                    file:null
                })
            })
    };

    onFileChange = event => {
        this.setState({
            file: event.target.files[0]
        })
    }
    onDrop = files => {
        const newFile = files[0];
        this.setState({ file: newFile, errorMessage: [] });
    };
    onCancel = () => {
        this.setState({ file: null, errorMessage: [] });
    };

    render() {
        const { modal } = this.state;
        const { file, loading } = this.state;
        const zoneStyle = {
            width: "100%",
            height: 150,
            border: "2px dashed #888",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column"
        };
        return (
            <div>
                <Modal isOpen={modal} toggle={this.toggle} size="xl" centered style={{ width: "770px" }}>
                    <ModalHeader>Upload offline approval</ModalHeader>
                    <ModalBody>
                    {file && <div className="col-md-12">
                        <Alert>{file.name}</Alert>    
                    </div>}
                    <Dropzone
                        disableClick
                        multiple={false}
                        style={zoneStyle}
                        onDrop={this.onDrop}
                        onFileDialogCancel={this.onCancel}
                    >
                        {({ isDragActive, isDragReject, open }) => {
                            if (isDragActive) {
                                return <p>File accepted</p>;
                            }
                            if (isDragReject) {
                                return <p>Files rejected</p>;
                            }
                            return (
                                <React.Fragment>
                                    <p>Dropp file here ... or</p>
                                    <button className="btn btn-primary" type="button" onClick={() => open()}>
                                        Browse File
                                    </button>
                                </React.Fragment>
                            );
                        }}
                    </Dropzone>

                    <div className="controls">
                        {loading && <ClipLoader size={38} color={"#007bff"} />}
                        <button disabled={!file || loading} className="btn btn-primary" onClick={this.onSubmit}>
                            Import File
                        </button>
                    </div>
                    </ModalBody>
                </Modal>
                
            </div>
        );
    }
}

export default UploadFileModal;
